import { consume } from '@lit/context'
import { LitElement, css, html } from 'lit'
import { customElement, property } from 'lit/decorators.js'
import { context } from './ep-nav-list'
import type { EPNavListContext } from './ep-nav-list'

/**
 * A nav list
 */
@customElement('ep-nav-list-group')
export class EPNavListGroup extends LitElement {

  @property({ type: Boolean, attribute: 'sticky-title', reflect: true })
  stickyTitle: boolean = false;

  @consume({ context: context, subscribe: true })
  @property({ attribute: false })
  provider?: EPNavListContext;

  render() {
    return html`
      <li>
        <div class="group-title" ?data-sticky=${this.stickyTitle} ?data-hassearchbar=${this.provider?.hasSearchBar}>
          <slot name="title"></slot>
        </div>
        <div part="children">
          <slot></slot>
        </div>
      </li>
    `
  }

  static styles = css`
    :host {
      --font-prose: ui-sans-serif,system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
      --color-soft-black: rgb(36, 41, 47);
    }

    * {
      box-sizing: border-box;
    }

    li {
      list-style: none;
    }

    .group-title {
      padding: 6px 16px;
      font-size: 12px;
      font-weight: 600;
      color: rgb(87, 96, 106);
      text-align: left;
    }

    .group-title[data-sticky] {
      position: sticky;
      top: 0px;
      height: 30px;
      backdrop-filter: saturate(180%) blur(10px);
      /* background-color: rgba(230, 230, 230, 0.15); */
      background-color: rgba(100,100,120,0.09);
      z-index: 1;
      border-radius: 6px;
    }

    .group-title[data-sticky][data-hassearchbar] {
      top: calc(32px + 2 * 8px - 8px);
    }
  `
}

declare global {
  interface HTMLElementTagNameMap {
    'ep-nav-list-group': EPNavListGroup
  }
}
